import React from 'react';
import './Spinner.css';
const Spinner = () => <div className="loader"></div>;

export default Spinner;
